import { LinearProgress } from '@mui/material';
import { Typography } from '../_base/Typography';

type Props = {
  progress: number;
};

export const VibLinearProgress = (props: Props) => {
  const { progress } = props;

  return (
    <div className="flex items-center">
      <LinearProgress
        variant="determinate"
        value={progress}
        className="w-full mr-main"
      />
      <Typography>{`${Math.round(progress)}%`}</Typography>
    </div>
  );
};
